class MultipassLogin extends HTMLElement {
    constructor() {
        super();

        this.checkUrlForErrors();
    }

    checkUrlForErrors() {
        const url = new URL(window.location.href);

        if (url.searchParams.get('error') !== 'true') {
            return;
        }

        this.displayError();
    }

    displayError() {
        const div = document.createElement('div');
        div.innerText = window.loginStrings.error;
        this.append(div);
    }
}

customElements.define('multipass-login', MultipassLogin);
